import { Avatar, Button, Grid, Typography } from "@mui/material";
import { Country } from "country-state-city";
import { useCallback } from "react";
import { useAlert } from "react-alert";
import { CandidateDetails } from "../../../redux/Hire/jobRequestApi";
import { stringAvatar } from "../../../utils/CommonFunction";

type Props = {
  candidate?: CandidateDetails;
  jobId?: string;
};

const CandidateSubHeader = ({ candidate, jobId }: Props) => {
  const hasExperience = (candidate?.candidateWorkExperiences || [])?.length > 0;
  let relevantRole:
    | CandidateDetails["candidateWorkExperiences"][number]
    | undefined;

  const alert = useAlert();
  if (hasExperience) {
    relevantRole = candidate?.candidateWorkExperiences.find((ex) => ex.current);
  }

  if (!relevantRole) {
    relevantRole = candidate?.candidateWorkExperiences[0];
  }

  // const [downloadDocUrl, { isFetching }] = useLazyDownloadDocumentQuery();

  // const alert = useAlert();

  // const downloadCV = useCallback(
  //   async (e: MouseEvent<HTMLButtonElement>) => {
  //     e.stopPropagation();
  //     if (candidate?.fileName) {
  //       try {
  //         const result = await downloadDocUrl({
  //           fileName: candidate.fileName,
  //         }).unwrap();
  //         window.open(result.link, "_blank");
  //       } catch (e) {
  //         alert.error("Error downloading document");
  //       }
  //     }
  //   },
  //   [alert, candidate, downloadDocUrl],
  // );

  const copyLink = useCallback(() => {
    if (candidate?.id) {
      const link = `${window.location.origin}/candidates/${candidate.id}?jobId=${jobId}`;
      navigator.clipboard
        .writeText(link)
        .then(() => {
          alert.success("Link copied to clipboard");
        })
        .catch(() => {
          alert.error("Failed to copy link");
        });
    }
  }, [candidate, jobId, alert]);

  return (
    <Grid
      container
      wrap="nowrap"
      alignItems="flex-start"
      gap={3}
      bgcolor={"#fff"}
      border={"1px solid #EBECF0"}
      borderRadius={"8px"}
      padding={4}
      mt={2}
    >
      <Grid item>
        <Avatar
          {...stringAvatar(candidate?.name || "Unknown Name", 96, {
            border: "6px solid #D9D9D9",
          })}
        />
      </Grid>
      <Grid container item wrap="nowrap" alignItems="center" gap={2}>
        <Grid container item direction={"column"} xs={12}>
          <Grid
            container
            item
            alignItems={"flex-end"}
            justifyContent={"space-between"}
          >
            <Typography fontSize={"32px"} fontWeight={700} color={"#3F4871"}>
              {candidate?.name || ""}
            </Typography>
            <Button
              variant="text"
              color="primary"
              sx={{ marginLeft: 1 }}
              size="small"
              startIcon={
                <img
                  src="/images/copy-icon.svg"
                  alt="copy"
                  width={16}
                  height={16}
                ></img>
              }
              onClick={copyLink}
            >
              Copy Link
            </Button>
          </Grid>

          <Grid
            container
            item
            alignItems={"flex-end"}
            justifyContent={"space-between"}
          >
            {relevantRole?.title && (
              <Typography fontSize={"18px"} fontWeight={600} color={"#1E293A"}>
                {relevantRole.title}
              </Typography>
            )}
            {candidate?.salaryIOTF && (
              <Typography fontSize={"18px"} fontWeight={600} color={"#1E293A"}>
                AUD ${candidate?.salaryIOTF} p/m
              </Typography>
            )}
          </Grid>
          <Grid container item alignItems="center" gap={1}>
            <Typography fontSize={"28px"} fontWeight={600} color={"#0F1829"}>
              {Country.getCountryByCode(candidate?.countryCode || "")?.flag ||
                ""}
            </Typography>
            <Typography fontSize={"14px"} fontWeight={600} color={"#0F1829"}>
              {candidate?.country || ""}
            </Typography>
          </Grid>
          <Grid container item alignItems="center" gap={1} mt={2}>
            <Button
              target="_top"
              variant="contained"
              color="primary"
              href={`mailto:${candidate?.email}`}
              disabled={!candidate?.email}
              sx={{
                minWidth: "175px",
              }}
            >
              Contact
            </Button>
            {/* <Button
              variant="outlined"
              color="primary"
              sx={{
                minWidth: "175px",
              }}
              onClick={downloadCV}
              disabled={!candidate?.fileName || isFetching}
            >
              {isFetching ? (
                <CircularProgress size={20}></CircularProgress>
              ) : (
                "View CV"
              )}
            </Button> */}
          </Grid>
        </Grid>
        {/* <Grid
          container
          item
          direction={"column"}
          xs={3}
          borderLeft={"1px solid #D9D9D9"}
          pl={3}
          height={"100%"}
        >
          <Grid container item height={"100%"}>
            <Typography fontSize={"20px"} fontWeight={600} color={"#0F1829"}>
              Skills and Experience
            </Typography>
          </Grid>
        </Grid> */}
      </Grid>
    </Grid>
  );
};

export default CandidateSubHeader;
